import React from "react";
import BannerFE from "../FindEase/BannerFE";
import PrototypeFE from "../FindEase/PrototypeFE";

const FindEase = () => {
  return (
    <div>
      <BannerFE />
      <PrototypeFE />
    </div>
  );
};

export default FindEase;
